import React from 'react'

import { TableList } from 'components/Case/CaseDetail/TableList'
import PurchaseInvoiceItemStatus from './PurchaseInvoiceItemStatus'
import PurchaseInvoiceItemTable from './PurchaseInvoiceItemTable'

export default ({ resource, piItems, caseCurrency }) => {
  return (
    <TableList>
      <div className="block-tree-container">
        <div className="block-tree-main"></div>
        {!!piItems.length &&
          piItems.map((piItem, index) => (
              <div key={index} className="invoice-order-block-purchase col-sm-11 offset-sm-1 d-flex flex-wrap mb-6">
              <div className="block-tree-item-offset"></div>
              <div className="block-tree-item">&nbsp;</div>
                <PurchaseInvoiceItemTable resource={resource} piItem={piItem} caseCurrency={caseCurrency} />
                <PurchaseInvoiceItemStatus resource={resource} piItem={piItem} />
              </div>
          ))}
      </div>
    </TableList>
  )
}
